module.exports = __webpack_public_path__ + "img/stamp_dummy.8f17f089.png";